import { render, staticRenderFns } from "./Launchpad.vue?vue&type=template&id=1a2ca130&scoped=true&"
import script from "./Launchpad.vue?vue&type=script&lang=ts&"
export * from "./Launchpad.vue?vue&type=script&lang=ts&"
import style0 from "./Launchpad.vue?vue&type=style&index=0&id=1a2ca130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2ca130",
  null
  
)

export default component.exports